import React, { useState, useEffect, useContext, useMemo } from "react";
import api from "../api/axios";
import { useNavigate } from "react-router-dom";
import { FaSyringe } from "react-icons/fa";
import { DataGridTable } from "../components";
import { UserContext } from "../context/UserContext";
import { useTranslation } from "../context/LanguageContext";
import "./UtilisationsPharmacie.css";

export default function UtilisationsPharmacie() {
  const { user } = useContext(UserContext);
  const { t } = useTranslation();
  const [utilisations, setUtilisations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  // États pour les filtres
  const [ficheSante, setFicheSante] = useState('');
  const [stock, setStock] = useState('');
  const [dateUtilisation, setDateUtilisation] = useState('');


  useEffect(() => {
    const fetchUtilisations = async () => {
      try {
        const params = new URLSearchParams();
        if (ficheSante) params.append('fiche_sante', ficheSante);
        if (stock) params.append('stock', stock);
        if (dateUtilisation) params.append('date_utilisation', dateUtilisation);

        const response = await api.get("/api/utilisations-produits/", { params });
        setUtilisations(response.data);
        setLoading(false);
      } catch (err) {
        setError(t.errorLoadingUsages);
        setLoading(false);
      }
    };
    fetchUtilisations();
  }, [ficheSante, stock, dateUtilisation]);

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleDateString('fr-FR');
  };


  const columns = useMemo(() => {
    const baseColumns = [
      {
        field: "produit_nom",
        headerName: t.product,
        flex: 1,
        minWidth: 200,
        headerAlign: 'left',
        align: 'left',
      },
      {
        field: "quantite_utilisee",
        headerName: t.quantityUsed,
        width: 150,
        headerAlign: 'right',
        align: 'right',
      },
      {
        field: "produit_unite",
        headerName: t.unit,
        width: 100,
        headerAlign: 'center',
        align: 'center',
      },
      {
        field: "animal_matricule",
        headerName: t.animal,
        flex: 1,
        minWidth: 150,
        headerAlign: 'left',
        align: 'left',
      },
      {
        field: "date_utilisation",
        headerName: t.usageDate,
        width: 160,
        headerAlign: 'center',
        align: 'center',
        valueGetter: (value) => formatDate(value),
      },
      {
        field: "notes",
        headerName: t.notes,
        flex: 1,
        minWidth: 200,
        headerAlign: 'left',
        align: 'left',
        valueGetter: (value) => value || "N/A",
      },
    ];

    return baseColumns;
  }, [t]);

  return (
    <div className="utilisations-pharmacie-page">
      <div className="title-badge">
        <FaSyringe className="page-title-icon" aria-hidden="true" />
        <span>{t.productUsages}</span>
      </div>
      {loading && <p>{t.loading}</p>}
      {error && <p className="error">{error}</p>}

      {!loading && !error && (
        <div className="utilisations-pharmacie-container">
          <h2 className="titleFiltre">{t.filters}</h2>
          <div className="filtres">
            <input
              type="number"
              className="filtre-fiche-sante"
              placeholder={t.healthRecordId}
              value={ficheSante}
              onChange={(e) => setFicheSante(e.target.value)}
            />
            <input
              type="number"
              className="filtre-stock"
              placeholder={t.stockId}
              value={stock}
              onChange={(e) => setStock(e.target.value)}
            />
            <input
              type="date"
              className="filtre-date"
              value={dateUtilisation}
              onChange={(e) => setDateUtilisation(e.target.value)}
              placeholder={t.usageDate}
            />
          </div>

          {/* DataGrid */}
          <DataGridTable
            rows={utilisations}
            columns={columns}
            loading={loading}
            storageKey="utilisations-pharmacie-zoom-level"
            initialSort={{ field: 'date_utilisation', sort: 'desc' }}
            pageSize={25}
            containerClassName="utilisations-grid-container"
          />
        </div>
      )}
    </div>
  );
}